var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1210_25963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0H4.5C3.8372 0.000793929 3.20178 0.264441 2.73311 0.73311C2.26444 1.20178 2.00079 1.8372 2 2.5V8H10V2.5C9.99921 1.8372 9.73556 1.20178 9.26689 0.73311C8.79822 0.264441 8.1628 0.000793929 7.5 0V0Z",
    fill: "#7266BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5C5.73478 9.5 5.48043 9.60536 5.29289 9.79289C5.10536 9.98043 5 10.2348 5 10.5C5 10.6978 5.05865 10.8911 5.16853 11.0556C5.27841 11.22 5.43459 11.3482 5.61732 11.4239C5.73891 11.4742 5.86863 11.4999 5.99898 11.5H4.50023C3.96997 11.4993 3.46162 11.2883 3.08666 10.9133C2.71176 10.5384 2.50079 10.0302 2.5 9.5H6ZM6 9.5C6.19778 9.5 6.39112 9.55865 6.55557 9.66853C6.72002 9.77841 6.84819 9.93459 6.92388 10.1173C6.99957 10.3 7.01937 10.5011 6.98079 10.6951C6.9422 10.8891 6.84696 11.0673 6.70711 11.2071C6.56725 11.347 6.38907 11.4422 6.19509 11.4808C6.13087 11.4936 6.06588 11.4999 6.00103 11.5H7.49977C8.03003 11.4993 8.53838 11.2883 8.91334 10.9133C9.28824 10.5384 9.49921 10.0302 9.5 9.5H6Z",
    fill: "#7266BA",
    stroke: "#7266BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1210_25963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePurple);
export default __webpack_public_path__ + "static/media/phone-purple.ec3c77a8e02fe1b5f7e083e217f29af5.svg";
export { ForwardRef as ReactComponent };